<template>
  <div>
    <!-- breadcrumb area start -->
    <div class="breadcrumb-area">
      <div class="row">
        <div class="col-md-12">
          <ol class="breadcrumb font-class">
            <li><a href="/#/home" v-on:click="sendMsg"><span class="fa fa-home"></span></a></li>
            <li class="active">联系我们</li>
          </ol>
        </div>
      </div>
    </div>
    <!-- breadcrumb area end -->

    <!-- contact information start -->
    <div class="contant-information pt-20">
      <div class="row">
        <div class="center_column col-xs-12 col-sm-12">
          <div class="rte">
<!--              <h1 class="title entry-title">关于博远</h1>-->
            <h1 style="text-align:center;font-size: 20px;font-size: 20px">总部</h1>
            <hr>
            <p class="pTitle">浙江总部</p>
            <p>地址：浙江省嘉兴市中环北路1856号</p>
            <p>电话：0573-82858090</p>
            <p>工作时间：周一至周五8：30-17：00</p>
          </div> <br><br>
          <div class="rte">
            <p class="pTitle">24小时销售支持</p>
            <hr>
            <p>匙总：18612451617</p>
            <p>刘总：18601190751</p>
            <p>沈总：15321220014</p>
          </div> <br><br>
        </div>
      </div>
    </div>
    <!-- contact information end -->
  </div>
</template>

<script>
import {getContactDetail} from '../utils/api'

export default {
  name: 'contact',
  data () {
    return {
      contactData: {},
      formLeft: {
        input1: '',
        input2: '',
        input3: ''
      }
    }
  },
  mounted () {
    this.getContactDetail()
  },
  methods: {
    render (String) {
      let temp = ''
      for (let item of String.split('\n')) {
        temp += item + '<br>'
      }
      return temp
    },
    async getContactDetail () {
      let contactData01 = await getContactDetail()
      if (localStorage.getItem('Language') === 'zh') {
        this.contactData = {
          address: this.render(contactData01.address_zh),
          email: contactData01.email,
          phone: contactData01.phone,
          work_time: this.render(contactData01.work_time_zh)
        }
      } else {
        this.contactData = {
          address: this.render(contactData01.address_en),
          email: contactData01.email,
          phone: contactData01.phone,
          work_time: this.render(contactData01.work_time_en)
        }
      }
      // console.log(this.contactData)
    },
    sendMsg () {
      this.$emit('headCurrent', 0)
      window.sessionStorage.setItem('currentIndex', 0)
    }
  }
}
</script>

<!-- 面包屑导航样式 -->
<style scoped>
  .breadcrumb>li+li:before {
    padding: 0 5px;
    color: #000;
    content: ">";
    font-weight: lighter;
  }

  .breadcrumb>li span{
    font-size: 16px;
  }
</style>

<!-- 内容样式 -->
<style scoped>
  .center_column{
    min-height: 400px;
  }

  .center_column p{
    font-size: 14px;
    line-height: 22px;
    margin: 0 0 9px;
    padding: 0;
    border: 0;
    vertical-align: baseline;
    color: #000;
    position: relative;
    font-family: 宋体;
  }

  .titleP, .pTitle{
    padding-left: 10px!important;
    font-size: 16px;
    font-weight: bold;
    margin: 10px 0 10px!important;
    text-indent: 0!important;
  }

  .titleP:before{
    position: absolute;
    left: -5px;
    top: 0;
    content: "\2726";
    font-size: 14px;
  }

  .rte {
    background: transparent none repeat scroll 0 0;
    text-indent: 26px;
    text-align: center;
  }

  .rte img{
    width: 100%;
  }

  .block{
    min-height: 250px;
    text-align: left;
  }

  h1, h2, h3, h4, h5, h6 {
    font-weight: 700;
    color: #000;
  }
</style>



// WEBPACK FOOTER //
// src/components/contact.vue